import { ERouterList } from '@internal/router/constants/router-list'

import InnerLayout from '@internal/layouts/inner-layout.vue'

import { auth } from '@internal/router/middleware/auth'

export const patients = [
  {
    path: '/patients',
    name: ERouterList.PATIENTS,
    component: () => import('@internal/pages/patients/index.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/patients/create',
    name: ERouterList.CREATE_PATIENT,
    component: () => import('@internal/pages/patients/new.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/patients/:patientId',
    name: ERouterList.PATIENT_PROFILE,
    component: () => import('@internal/pages/patients/_patientId/index.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/patients/print-qr-codes',
    name: ERouterList.PATIENTS_LOCATION_PRINT_QR_CODES,
    component: () => import('@internal/pages/patients/print-qr-codes.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/patients/:patientId/edit',
    name: ERouterList.EDIT_PATIENT_PROFILE,
    component: () => import('@internal/pages/patients/_patientId/edit.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/patients/:patientId/insurance/new',
    name: ERouterList.NEW_PATIENT_INSURANCE,
    component: () => import('@internal/pages/patients/_patientId/insurance/new.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/patients/:patientId/insurance/:insuranceId/edit',
    name: ERouterList.EDIT_PATIENT_INSURANCE,
    component: () => import('@internal/pages/patients/_patientId/insurance/_insuranceId/edit.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/patients/:patientId/consent/new',
    name: ERouterList.NEW_PATIENT_CONSENT,
    component: () => import('@internal/pages/patients/_patientId/consent/new/index.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/patients/:patientId/consent/new/sign-online',
    name: ERouterList.NEW_PATIENT_CONSENT_SIGN_ONLINE,
    component: () => import('@internal/pages/patients/_patientId/consent/new/sign-online.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/patients/:patientId/consent/new/upload-signed',
    name: ERouterList.NEW_PATIENT_CONSENT_UPLOAD_SIGNED,
    component: () => import('@internal/pages/patients/_patientId/consent/new/upload-signed.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/patients/:patientId/consent/new/verbal/:signerId',
    name: ERouterList.NEW_PATIENT_CONSENT_VERBAL,
    component: () => import('@internal/pages/patients/_patientId/consent/new/verbal/_signerId.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/patients/:patientId/consent/decline',
    name: ERouterList.DECLINE_PATIENT_CONSENT,
    component: () => import('@internal/pages/patients/_patientId/consent/decline.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/patients/:patientId/edit-programs-participation',
    name: ERouterList.EDIT_PATIENT_PROGRAMS_PARTICIPATION,
    component: () => import('@internal/pages/patients/_patientId/edit-program-participation.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/patients/:patientId/contacts/new',
    name: ERouterList.NEW_PATIENT_CONTACT,
    component: () => import('@internal/pages/patients/_patientId/contacts/new.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/patients/:patientId/contacts/:contactId',
    name: ERouterList.PATIENT_CONTACT,
    component: () => import('@internal/pages/patients/_patientId/contacts/_contactId/index.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/patients/:patientId/contacts/:contactId/edit',
    name: ERouterList.EDIT_PATIENT_CONTACT,
    component: () => import('@internal/pages/patients/_patientId/contacts/_contactId/edit.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
]

export default patients
